/**
 * Breakpoint Tokens
 * Responsive breakpoints matching Chakra UI + project customizations
 */

export const breakpoints = {
  sm: '320px',
  '2sm': '380px',
  md: '768px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1600px',
  '3xl': '1920px',
};

// Breakpoint values as numbers (for JS comparisons)
export const breakpointValues = {
  sm: 320,
  '2sm': 380,
  md: 768,
  lg: 960,
  xl: 1200,
  '2xl': 1600,
  '3xl': 1920,
};

// Media query strings
export const breakpointQueries = {
  sm: `@media (min-width: ${breakpoints.sm})`,
  '2sm': `@media (min-width: ${breakpoints['2sm']})`,
  md: `@media (min-width: ${breakpoints.md})`,
  lg: `@media (min-width: ${breakpoints.lg})`,
  xl: `@media (min-width: ${breakpoints.xl})`,
  '2xl': `@media (min-width: ${breakpoints['2xl']})`,
  '3xl': `@media (min-width: ${breakpoints['3xl']})`,
};

export default breakpoints;
